module.exports = __webpack_public_path__ + "media/src/images/zu_04before_start05-b4f587439a8504aa355f9a5a0827e8ee.png";